import { Dayjs, OpUnitType } from 'dayjs'

import { isBefore } from './isBefore'

/**
 * Gets the latest of the two datetimes.
 */
export function latest(a: Dayjs, b: Dayjs, unit?: OpUnitType) {
    if (isBefore(a, b, unit)) {
        return b
    }
    return a
}
